import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	and: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	startDateLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	endDateLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	and: {
		id: 'jql-builder-basic-datetime.between-dates.and',
		defaultMessage: 'and',
		description: 'Conjunction connecting start and end dates in a date interval',
	},
	startDateLabel: {
		id: 'jql-builder-basic-datetime.between-dates.start-date-label',
		defaultMessage: 'Choose a start date',
		description: 'Label for the start date',
	},
	endDateLabel: {
		id: 'jql-builder-basic-datetime.between-dates.end-date-label',
		defaultMessage: 'Choose an end date',
		description: 'Label for the end date',
	},
});
export default messages;
